import * as Sentry from '@sentry/react';
import { pushError } from '@asurion-core/frontend-utils/lib/WebObservability';
import environment from '../../environment';

export const logMessage = (message) => {
  if (environment.observability.isTelemetryEnabled) {
    try {
      pushError({ message });
    } catch (e) {
      Sentry.captureException(e);
    }
  }
  Sentry.captureMessage(message);
  console.log(message);
};

export const logError = ({ customMessage, customFields, error }) => {
  let tags = customMessage ? { ...customFields, customMessage } : customFields;

  // If the error is a TypeError, is was likely caught by one of our error boundaries. If this was the case, in order to pass the tags through to Sentry we have to create a new error. This will result in a duplicated issue in Sentry, but will preserve the customFields from the error boundary. This is due to Sentry SDK automatically attaching global handlers for uncaught Exceptions. this can be configured to stop this global catching, but until we are using our ErrorService everywhere that would likely result in uncaught errors.
  if (error && error.name === 'TypeError') {
    error = new Error(error);
  }

  if (environment.observability.isTelemetryEnabled) {
    try {
      pushError({ message: error, context: { tags } });
    } catch (e) {
      Sentry.captureException(e);
    }
  }

  Sentry.captureException(error, { tags });
  console.error(error, tags);
};

export const init = Sentry.init;
export const configure = Sentry.configureScope;
